import React, { Component } from "react";

import PropTypes from "prop-types";
import { View, Text ,Platform} from "react-native";
import { translate } from "../locales/translate";
import {englishToPersianNumber}from "../util";
import Select from "../nativeBase-ui/Select";
 

/**@argument {Component <Props,state>} */
class TimePicker extends Component {
  static propTypes = {
    startTime: PropTypes.string,
    endTime: PropTypes.string,
    onSelect: PropTypes.func,
    interval: PropTypes.number,
    selectedStartTime: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedStartItem: this.props.selectedStartItem || null,
      startTime: this.props.startTime,
      endTime: this.props.endTime,
      interval: this.props.interval,
      listItems: [],
    };
  }
  componentDidMount() {
    let { startTime, endTime, interval } = this.state;
    // this.generateList(startTime, endTime, interval);
    // console.log("endStart", this.props.startTime, this.props.endTime);
  }

  stringTimeToDate(strTime) {
    try {
      if (strTime) {
        var startDateTime = new Date(0);
        var startPieces = strTime.split(":");
        startDateTime.setHours(startPieces[0]);
        startDateTime.setMinutes(startPieces[1]);
        return startDateTime;
      }
      return undefined;
    } catch (ex) {
      throw ex;
    }
  }
  toDigit(num) {
    if (Number(num) != NaN) {
      return (100 + num).toString().substr(1);
    }
    return num;
  }
  generateList() {
    let { startTime, endTime, interval } = this.props;
    var _startTime = this.stringTimeToDate(startTime);
    var _endTime = this.stringTimeToDate(endTime);

    var itemDate = this.stringTimeToDate(startTime);
    itemDate.setMinutes(0);
    if (_startTime.getMinutes() > 0) {
      while (itemDate.getTime() < _startTime.getTime()) {
        itemDate = new Date(itemDate.getTime() + interval);
      }
    }
    this.setState({ listItems: [] });
    var listItems = [];
    while (Math.abs(_endTime.getTime() - itemDate.getTime()) >= interval) {
      var strItem = this.dateToString(itemDate);
      itemDate = new Date(itemDate.getTime() + interval);
      listItems.push(strItem);
    }
    this.setState({ listItems: listItems, startTime, endTime, interval });
  }

  dateToString(dd) {
    var hh = this.toDigit(dd.getHours());
    var mm = this.toDigit(dd.getMinutes());
    var strItem = `${hh}:${mm}`;
    return strItem;
  }
  handelOnSelect(value) {
    var selectedEndItem = this.stringTimeToDate(value);
    selectedEndItem = new Date(selectedEndItem.getTime() + this.props.interval);
    selectedEndItem = this.dateToString(selectedEndItem);

    this.setState({ selectedStartItem: value }, () => {
      this.props.onSelect &&
        this.props.onSelect(this.state.selectedStartItem, selectedEndItem);
    });
  }
  render() {
    if (
      this.props.startTime != this.state.startTime ||
      this.props.endTime != this.state.endTime ||
      this.props.interval != this.state.interval
    ) {
      this.generateList();
    }
    return (
      <View>
        <Select
          // itemTextStyle={{ fontFamily: "IRANSansWebFaNum"  }}
          label={null}          
          data={this.state.listItems.map((i) => {
            return { label: i, value: i };
          })}
          value={Platform.OS =="web" ?this.state.selectedStartItem :
            englishToPersianNumber(this.props.selectedStartTime) || translate("api.serviceTime")
          }
          onChangeText={(value, index, data) => {
            this.handelOnSelect(value);
          }}
          // overlayStyle={{ fontFamily: "IRANSansWebFaNum" ,}}
        ></Select>
      </View>
    );
  }
}

export default TimePicker;
